import classNames from "classnames";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import ProtectedDownload from "../common/ProtectedDownload";

interface IParams {
  url: string;
}

export const DownloadZipButton: React.FC<IParams> = ({ url }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["features"], translationHookOptions);

  return (
    <>
      <ProtectedDownload
        hasLoaderModal={true}
        url={url}
        children={
          <Button
            className={classNames(
              "genericButton",
              `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                theme!.buttonTextColor
              }`
            )}
          >
            {t("download_zip_button")}
          </Button>
        }
      ></ProtectedDownload>
    </>
  );
};
